import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getCustomer,
  getParam,
  getMaterial,
  postApproval,
  postFile,
  getFile,
  updateDraft,
  getInvoice,
  getBatch,
} from "./withoutRtvAPI";

const initialState = {
  data: [],
  dataCustomer: [],
  dataMaterial: [],
  dataBatch: [],
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: [],
  reasonParam: [],
  salesDivisionParam: [],
  distributionChannelParam: [],
  customerData: [],
  block: [],
  uploadFileId: null,
  reason: null,
  draft: [],
};
export const fetchInvoice = createAsyncThunk(
  "withoutRtv/fetchInvoice",
  async (payload) => {
    const response = await getInvoice(payload);
    return response.data;
  }
);
export const fetchBatch = createAsyncThunk(
  "withoutRtv/fetchBatch",
  async (payload) => {
    const response = await getBatch(payload);
    return response.data;
  }
);
export const fetchCustomer = createAsyncThunk(
  "withoutRtv/fetchCustomer",
  async (payload) => {
    const response = await getCustomer(payload);
    return response.data;
  }
);

export const fetchMaterial = createAsyncThunk(
  "withoutRtv/fetchMaterial",
  async (payload) => {
    const response = await getMaterial(payload);
    return response.data;
  }
);

export const updateReasonParam = createAsyncThunk(
  "reportHeader/updateReasonParam",
  async (payload) => {
    return payload;
  }
);

export const fetchReasonParam = createAsyncThunk(
  "withoutRtv/fetchReasonParam",
  async (payload) => {
    const response = await getParam(payload);
    return response.data;
  }
);
export const updateSalesDivisionParam = createAsyncThunk(
  "reportHeader/updateSalesDivisionParam",
  async (payload) => {
    return payload;
  }
);

export const fetchSalesDivisionParam = createAsyncThunk(
  "withoutRtv/fetchSalesDivisionParam",
  async (payload) => {
    const response = await getParam(payload);
    return response.data;
  }
);

export const updateDistributionChannelParam = createAsyncThunk(
  "withoutRtv/updateDistributionChannelParam",
  async (payload) => {
    return payload;
  }
);

export const fetchDistributionChannelParam = createAsyncThunk(
  "withoutRtv/fetchDistributionChannelParam",
  async (payload) => {
    const response = await getParam(payload);
    return response.data;
  }
);

export const createApproval = createAsyncThunk(
  "withoutRtv/createApproval",
  async (payload) => {
    const response = await postApproval(payload);
    return response;
  }
);

export const uploadFile = createAsyncThunk(
  "withoutRtv/uploadFile",
  async ({ file }) => {
    const response = await postFile(file);
    return response.data;
  }
);

export const getAttachmentId = createAsyncThunk(
  "withoutRtv/getAttachmentId",
  async (payload) => {
    const response = await getFile(payload);
    return response.data;
  }
);

export const editDraft = createAsyncThunk(
  "withoutRtv/editDraft",
  async ({ params, id }) => {
    const response = await updateDraft(params, id);
    console.log(params, id);
    return response;
  }
);

export const withoutRtvSlice = createSlice({
  name: "withoutRtv",
  initialState,
  reducers: {
    resetData: (state) => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
    setBlock: (state, action) => {
      state.block = action.payload;
    },
    setReason: (state, action) => {
      state.reason = action.payload;
    },
    setDraft: (state, action) => {
      state.draft = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchInvoice.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchInvoice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.pageNo = action.payload.pageNo;
        state.pageSize = action.payload.pageSize;
        state.totalRecord = action.payload.totalRecord;
      })
      .addCase(fetchBatch.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchBatch.fulfilled, (state, action) => {
        state.loading = false;
        state.dataBatch = action.payload.data;
        state.pageNo = action.payload.pageNo;
        state.pageSize = action.payload.pageSize;
        state.totalRecord = action.payload.totalRecord;
      })
      .addCase(fetchCustomer.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCustomer.fulfilled, (state, action) => {
        state.loading = false;
        state.dataCustomer = action.payload.data;
        state.pageNo = action.payload.pageNo;
        state.pageSize = action.payload.pageSize;
        state.totalRecord = action.payload.totalRecord;
      })
      .addCase(fetchMaterial.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMaterial.fulfilled, (state, action) => {
        state.loading = false;
        state.dataMaterial = action.payload.data;
        state.pageNo = action.payload.pageNo;
        state.pageSize = action.payload.pageSize;
        state.totalRecord = action.payload.totalRecord;
      })

      .addCase(updateReasonParam.fulfilled, (state, action) => {
        state.reasonParam = action.payload;
      })
      .addCase(fetchReasonParam.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchReasonParam.fulfilled, (state, action) => {
        state.loading = false;
        state.reasonParam = action.payload.data;
      })
      .addCase(updateSalesDivisionParam.fulfilled, (state, action) => {
        state.salesDivisionParam = action.payload;
      })
      .addCase(fetchSalesDivisionParam.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSalesDivisionParam.fulfilled, (state, action) => {
        state.loading = false;
        state.salesDivisionParam = action.payload.data;
      })
      .addCase(updateDistributionChannelParam.fulfilled, (state, action) => {
        state.distributionChannelParam = action.payload;
      })
      .addCase(fetchDistributionChannelParam.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDistributionChannelParam.fulfilled, (state, action) => {
        state.loading = false;
        state.distributionChannelParam = action.payload.data;
      })
      .addCase(createApproval.pending, (state) => {
        state.loading = true;
      })
      .addCase(createApproval.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createApproval.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(uploadFile.pending, (state) => {
        state.loading = true;
      })
      .addCase(uploadFile.fulfilled, (state, action) => {
        state.loading = false;
        state.uploadFileId = action.payload.data;
      })
      .addCase(uploadFile.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(editDraft.pending, (state) => {
        state.loading = true;
      })
      .addCase(editDraft.fulfilled, (state, action) => {
        state.loading = false;
        state.updateR = action.payload;
      });
  },
});

export const {
  resetData,
  setSelected,
  setBlock,
  setReason,
  setDraft,
} = withoutRtvSlice.actions;

export const selectData = (state) => state.withoutRtv.data;
export const selectDataMaterial = (state) => state.withoutRtv.dataMaterial;
export const selectDataCustomer = (state) => state.withoutRtv.dataCustomer;
export const selectDataBatch = (state) => state.withoutRtv.dataBatch;
export const selectLoading = (state) => state.withoutRtv.loading;
export const selectError = (state) => state.withoutRtv.error;
export const selectPageNo = (state) => state.withoutRtv.pageNo;
export const selectPageSize = (state) => state.withoutRtv.pageSize;
export const selectTotalRecord = (state) => state.withoutRtv.totalRecord;
export const selectSelected = (state) => state.withoutRtv.selected;
export const selectReason = (state) => state.withoutRtv.reason;
export const selectBlock = (state) => state.withoutRtv.block;
export const selectReasonParam = (state) => state.withoutRtv.reasonParam;
export const selectSalesDivisionParam = (state) =>
  state.withoutRtv.salesDivisionParam;
export const selectDistributionChannelParam = (state) =>
  state.withoutRtv.distributionChannelParam;
export const selectUploadFileId = (state) => state.withoutRtv.uploadFileId;
export const selectDraft = (state) => state.withoutRtv.draft;

export default withoutRtvSlice.reducer;
